<template>
<div>
  <PricingTopActionWrapper class="popup-wrapper"></PricingTopActionWrapper>
  <PricingPageAlert></PricingPageAlert>
  <PricingSheet></PricingSheet>
</div>
</template>
<script>
import PricingTopActionWrapper from './PricingTopActionWrapper'
import PricingPageAlert from './PricingPageAlert'
import PricingSheet from './PricingSheet'
export default {
  name: 'ProjectPagePricing',
  data () {
    return {
    }
  },
  props: [],
  components: {
    PricingTopActionWrapper,
    PricingPageAlert,
    PricingSheet
  },
  computed: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  updated () {
  }
}
</script>
<style scoped lang="scss">
@import "../../../styles/components/_pricingpage.scss";
</style>
